import * as React from 'react'
import { ReactElement } from 'react'
import { Textarea, TextareaProps } from '@fluentui/react-components'
import FormikField, { FormikSubFieldProps } from './FormikField'
import { RefAttributes } from '@fluentui/react-utilities'

export default function FormikTextareaField<Values>(props: FormikSubFieldProps<TextareaProps & RefAttributes<TextareaProps>, Values>): ReactElement {
    return (
        <FormikField<TextareaProps, Values>
            component={Textarea}
            {...props}
            componentProps={{ rows: 3, resize: 'vertical', ...props.componentProps }}
        />
    )
}
